
<div>
  <page-header>
    <div class="text-nowrap text-dark ml-3 mr-3">
      <h4 class="form-check-label">
        {{ boardTitle }}
      </h4>
    </div>

    <router-link
      tag="div"
      class="badgebutton active text-nowrap ml-4"
      :to="{ name: 'Board', params: { id: $route.params.id } }"
    >
      <i class="far fa-caret-left"></i>
      Back to Board
    </router-link>
  </page-header>

  <BoardSettings />
</div>
